<template>
  <div class="bg-muted-foreground/40 mx-auto mt-4 h-2 w-25 rounded-full" />
</template>
